export const departmentsObject = [
  {
    faculty: "Applied Science & Engineering",
    departments: [
      {
        department: "Chemical Engineering & Applied Chemistry",
        programs: [
          "MASC-Chemical Engineering & Applied Chemistry",
          "MENG-Chemical Engineering & Applied Chemistry",
          "MENG-Chemical Engineering & Applied Chemistry (Extended Option)",
          "MENG-Chemical Engineering & Applied Chemistry (summer start)",
          "PHD-Chemical Engineering & Applied Chemistry",
          "Special Student - CHE",
        ],
      },
      {
        department: "Civil and Mineral Engineering",
        programs: ["PhD - CIVIL", "Masters - CIVIL", "Special Student - CIVIL"],
      },
      {
        department: "Electrical & Computer Engineering",
        programs: [
          "MASC-Electrical & Computer Engineering",
          "MENG-Electrical & Computer Engineering",
          "MENG-Electrical & Computer Engineering (Extended Option)",
          "MENG-Electrical & Computer Engineering (summer start)",
          "PHD-Electrical & Computer Engineering",
          "PHD (direct entry) - Electrical & Computer Engineering",
          "Special Student - ECE",
        ],
      },
      {
        department: "Institute for Aerospace Studies (UTIAS)",
        programs: [
          "MASC-Aerospace Science & Engineering",
          "MENG-Aerospace Science & Engineering",
          "MENG-Aerospace Science & Engineering (Extended Option)",
          "MENG-Aerospace Science & Engineering (summer start)",
          "PHD-Aerospace Science & Engineering",
          "PHD-Aerospace Science & Engineering (flex-time)",
          "Special Student - AER",
        ],
      },

      {
        department: "Institute of Biomedical Engineering",
        programs: [
          "MASc - Biomedical Engineering",
          "MEng - Biomedical Engineering",
          "PhD - Biomedical Engineering",
          "PhD (direct entry) - Biomedical Engineering",
          "Special Student - BME",
        ],
      },

      {
        department: "Materials Science & Engineering",
        programs: [" PhD - MMS", "Masters - MMS", "Special Student - MMS"],
      },

      {
        department: "Mechanical & Industrial Engineering",
        programs: [
          "MASc-Mechanical & Industrial Engineering",
          "Master of Engineering Design and Manufacturing",
          "MEng-Mechanical & Industrial Engineering",
          "MEng-Mechanical & Industrial Engineering (Extended Option)",
          "MEng-Mechanical & Industrial Engineering (summer start)",
          "Professional Masters - Mechanial & Industrial Engineering",
          "PhD-Mechanical & Industrial Engineering",
          "PhD-Mechanical & Industrial Engineering (Flex time)",
          "PhD (direct entry) - Mechanical & Industrial Engineering",
          "Special Student - MIE",
        ],
      },
    ],
  },
  {
    faculty: "Arts & Science",
    departments: [
      {
        department: "Anthropology",
        programs: [
          "MA-Anthropology",
          "MSc-Anthropology",
          "PHD-Anthropology",
          "PHD-Anthropology (direct entry)",
          "Master of Philosophy",
          "Special Student - ANT",
        ],
      },
      {
        department: "Art History",
        programs: ["MA - FAR", "PhD - FAR", "Special Student - FAR"],
      },
      {
        department: "Astronomy and Astrophysics",
        programs: [
          "MSC - Astronomy & Astrophysics",
          "PHD - Astronomy",
          "PHD (direct entry) - Astronomy",
          "Special Student - AST",
        ],
      },
      {
        department: "Cell & Systems Biology",
        programs: [
          "MSC - Cell and Systems Biology",
          "PhD - Cell and Systems Biology",
          "Special Student - CSB",
        ],
      },
      {
        department: "Centre for Comparative Literature",
        programs: [
          "MA-Comparative Lit (1 Year)",
          "MA-Comparative Lit (2 Years)",
          "PhD-Comparative Literature",
          "Special Student - COL",
        ],
      },
      {
        department: "Centre for Criminology and Sociolegal Studies",
        programs: ["Masters - CRIM", "PhD - CRIM", "Special Student - CRIM"],
      },
      {
        department: "Centre for Drama, Theatre & Performance Studies",
        programs: ["Masters - DRAMA", "PhD - DRAMA", "Special Student - DRAMA"],
      },
      {
        department: "Centre for European, Russian & Eurasian Studies",
        programs: ["Masters - CERES", "PhD - CERES", "Special Student - CERES"],
      },
      {
        department: "Centre for Industrial Relations & Human Resources",
        programs: [
          "Professional Masters - Industrial Relations & Human Resources",
          "Master of Industrial Relations & Human Resources (advanced standing)",
          "Master of Industrial Relations (2sess)",
          "Master of Industrial Relations",
          "PhD-Industrial Relations",
          "PhD (direct entry) - Industrial Relations",
          "Special Student - IRE",
        ],
      },
      {
        department: "Centre for Medieval Studies",
        programs: [
          "MA-Medieval Studies (1 Year)",
          "MA-Medieval Studies (2 Years)",
          "PHD-Medieval Studies",
          "PHD (direct entry) - Medieval Studies",
          "Special Student - MST",
        ],
      },
      {
        department: "Chemistry",
        programs: ["MSC-Chemistry", "PHD-Chemistry", "Special Student - CHM"],
      },
      {
        department: "Cinema Studies Institute",
        programs: ["Masters - CINE", "PhD - CINE", "Special Student - CINE"],
      },
      {
        department: "Classics",
        programs: ["Masters - CLAS", "PhD - CLAS", "Special Student - CLAS"],
      },
      {
        department: "Computer Science",
        programs: [
          "Master of Science in Applied Computing",
          "MSc-Computer Science",
          "PHD-Computer Science",
          "PhD - Computer Science (Transition)",
          "PHD (direct entry) - Computer Science",
          "Special Student - CSC",
        ],
      },
      {
        department: "Dept for the Study of Religion",
        programs: ["MA-Religion", "PhD - RLG", "Special Student - RLG"],
      },
      {
        department: "Dept of Statistical Sciences",
        programs: ["Masters - STAT", "PhD - STAT", "Special Student - STAT"],
      },
      {
        department: "Earth Sciences",
        programs: ["Masters - ES", "PhD - ES", "Special Student - ES"],
      },
      {
        department: "East Asian Studies",
        programs: [
          "MA-East Asian Studies",
          "MA-East Asian Studies (2 year)",
          "PHD-East Asian Studies",
          "PHD (direct entry) - East Asian Studies",
          "Special Student - EAS",
        ],
      },
      {
        department: "Ecology & Evolutionary Biology",
        programs: [
          "MSC-Ecology & Evolutionary Biology",
          "MSC-Ecology & Evolutionary Biology (May start)",
          "PHD-Ecology & Evolutionary Bio",
          "PHD (direct entry) - Ecology and Evolutionary Biology",
          "Doctor of Philosophy, under a joint educational",
          "Special Student - EEB",
        ],
      },
      {
        department: "Economics",
        programs: [
          "MA-Economics (General Program)1yr",
          "MA - Economics (2 Year)",
          "Master of Financial Economics",
          "PhD-Economics",
          "PhD (direct entry) - Economics",
          "Special Student - ECO",
        ],
      },
      {
        department: "English",
        programs: [
          "MA-English (1 Year)",
          "PhD-English",
          "PhD (direct entry) - English",
          "Special Student - ENG",
        ],
      },
      {
        department: "French Language & Literature",
        programs: [
          "MA-French (1 Year)",
          "PhD-French",
          "PhD (direct entry) - French",
          "Special Student - FRE",
        ],
      },
      {
        department: "Geography and Planning",
        programs: [
          "MA-Geography",
          "MSC - Geography",
          "PHD-Geography",
          "PHD (direct entry) - Geography",
          "Special Student - GGR",
        ],
      },
      {
        department: "Germanic Languages & Literatures",
        programs: [
          "MA-Germanic Language & Literature",
          "PhD-Germanic Language & Literature",
          "PhD-German Lit, Cultr & Thry",
          "Special Student - GER",
        ],
      },
      {
        department: "History",
        programs: [
          "PhD-History",
          "PhD (direct entry) - History",
          "Special Student - HIS",
        ],
      },
      {
        department:
          "Institute for the History and Philosophy of Science & Technology",
        programs: ["Masters - IHPST", "PhD - IHPST", "Special Student - IHPST"],
      },
      {
        department: "Italian Studies",
        programs: [
          "MA-Italian Studies",
          "PhD-Italian Studies",
          "PhD (direct entry) - Italian Studies",
          "Special Student - ITA",
        ],
      },
      {
        department: "Linguistics",
        programs: [
          "MA-Linguistics (1 Year)",
          "MA-Linguistics (1.5 Years)",
          "MA-Linguistics (2 Years)",
          "PHD-Linguistics",
          "Special Student - LIN",
        ],
      },
      {
        department: "Mathematics",
        programs: [
          "MMF - Master of Mathematical F",
          "MSc-Mathematics (1yr)",
          "MSC-Mathematics (1.5 yr)",
          "MSC-Mathematics (2yr)",
          "Master of Science in Teaching",
          "PHD-Mathematics",
          "PHD (direct entry) - Mathematics",
          "Special Student - MAT",
        ],
      },
      {
        department: "Munk School of Global Affairs and Public Policy",
        programs: ["Masters - GLAF", "PhD - GLAF", "Special Student - GLAF"],
      },
      {
        department: "Near & Middle Eastern Civilizations",
        programs: [
          "MA-Near & Mid East Civ",
          "MA-Near & Mid.East.Civ.(1 Yr.)",
          "MA-Near & Mid.East.Civ.(2 Yr.)",
          "Masters of Near & Middle Eastern Civilizations",
          "PHD-Near & Middle Eastern Civ",
          "Special Student - NMC",
        ],
      },
      {
        department: "Philosophy",
        programs: [
          "MA-Philosophy",
          "MA-Philosophy (1yr)",
          "MA-Philosophy (2YR)",
          "PHD-Philosophy",
          "PHD (direct entry) - Philosophy",
          "Special Student - PHL",
        ],
      },
      {
        department: "Physics",
        programs: [
          "MSC-Physics",
          "MSCT - Physics",
          "PHD-Physics",
          "Special Student - PHY",
        ],
      },
      {
        department: "Political Science",
        programs: [
          "MA-Political Economy",
          "PhD-Political Economy",
          "MA-Political Science",
          "PHD - Political Science",
          "PhD (direct entry) - Political Science",
          "Special Student - POL",
        ],
      },
      {
        department: "Psychology",
        programs: [
          "MA-Psychology",
          "PhD (direct entry)-Psychology",
          "Special Student - PSY",
        ],
      },
      {
        department: "Slavic Languages & Literatures",
        programs: [
          "MA-Slavic Languages & Literature",
          "MA - Slavic (2 Years)",
          "PhD-Slavic Languages & Literature",
          "Special Student - SLA",
        ],
      },
      {
        department: "Sociology",
        programs: ["MA-Sociology", "PhD-Sociology", "Special Student - SOC"],
      },
      {
        department: "Spanish",
        programs: [
          "MA-Spanish & Portuguese",
          "PHD-Spanish & Portuguese",
          "Special Student - SPA",
        ],
      },
      {
        department: "Women & Gender Studies Institute",
        programs: ["Masters - WGSI", "PhD - WGSI", "Special Student - WGSI"],
      },
    ],
  },
  {
    faculty: "Dalla Lana School of Public Health",
    departments: [
      {
        department: "Institute of Health Policy, Management & Evaluation",
        programs: ["Masters - HLADM", "PhD - HLADM", "Special Student - HLADM"],
      },
      {
        department: "Public Health Sciences",
        programs: ["Masters - PHSCI", "PhD - PHSCI", "Special Student - PHSCI"],
      },
    ],
  },

  {
    faculty: "Dentistry",
    departments: [
      {
        department: "Faculty of Dentistry",
        programs: ["Masters - DENT", "PhD - DENT", "Special Student - DENT"],
      },
    ],
  },
  {
    faculty: "Factor-Inwentash Faculty of Social Work",
    departments: [
      {
        department: "Factor-Inwentash Faculty of Social Work",
        programs: [
          "Doctor of Social Work",
          "Master of Social Work (advanced standing)",
          "Master of Social Work (two year program)",
          "Master of Social Work (advanced standing; summer start)",
          "PhD-Social Work",
          "PHD-Social Work (Flex-time option)",
          "Special Student - SWK",
        ],
      },
    ],
  },
  {
    faculty: "Information",
    departments: [
      {
        department: "Faculty of Information",
        programs: [
          "Master of Information",
          "Master of Information Science",
          "Masters Information Sciences",
          "Master of Information Studies",
          "Master of Library Science",
          "PHD - Information Studies",
          "Special Student - FIS",
        ],
      },
    ],
  },
  {
    faculty: "John H. Daniels Faculty of Architecture, Landscape & Design",
    departments: [
      {
        department:
          "John H. Daniels Faculty of Architecture, Landscape & Design",
        programs: [
          "Master of Science in Forestry",
          "PHD (direct entry) - Forestry",
          "Special Student - FOR",
          "Masters - ARCLA",
          "PhD - ARCLA",
          "Special Student - ARCLA",
        ],
      },
    ],
  },
  {
    faculty: "Kinesiology and Physical Education",
    departments: [
      {
        department: "Kinesiology",
        programs: ["Masters - EXSCI", "PhD - EXSCI", "Special Student - EXSCI"],
      },
    ],
  },
  {
    faculty: "Law",
    departments: [
      {
        department: "Faculty of Law",
        programs: [
          "Global Professional Master of Laws",
          "Master of Laws",
          "Master of Studies in Law",
          "Doctor of Juridical Science (direct entry)",
          "Special Student - LAW",
        ],
      },
    ],
  },
  {
    faculty: "Lawrence Bloomberg Faculty of Nursing",
    departments: [
      {
        department: "Lawrence Bloomberg Faculty of Nursing",
        programs: ["Masters - NURS", "PhD - NURS", "Special Student - NURS"],
      },
    ],
  },
  {
    faculty: "Leslie Dan Faculty of Pharmacy",
    departments: [
      {
        department: "Pharmaceutical Sciences",
        programs: [
          "MSC-Pharmaceutical Sciences",
          "Master of Science in Pharmacy",
          "PhD - Pharmaceutical Sciences",
          "PHD (direct entry) - Pharmaceutical Sciences",
          "Special Student - PHM",
        ],
      },
    ],
  },
  {
    faculty: "Mississauga Campus",
    departments: [
      {
        department: "Institute for Management and Innovation ",
        programs: ["Masters - IMI", "PhD - IMI", "Special Student - IMI"],
      },
    ],
  },
  {
    faculty: "Music",
    departments: [
      {
        department: "Music",
        programs: ["Masters - MUSIC", "PhD - MUSIC", "Special Student - MUSIC"],
      },
    ],
  },
  {
    faculty: "Ontario Institute for Studies in Education",
    departments: [
      {
        department: "Applied Psychology & Human Development",
        programs: ["Masters - APHD", "PhD - APHD", "Special Student - APHD"],
      },
      {
        department: "Curriculum, Teaching, & Learning",
        programs: ["Masters - CTL", "PhD - CTL", "Special Student - CTL"],
      },
      {
        department: "Leadership Higher & Adult Education",
        programs: ["Masters - LHAE", "PhD - LHAE", "Special Student - LHAE"],
      },
      {
        department: "Social Justice Education",
        programs: ["Masters - HSSJE", "PhD - HSSJE", "Special Student - HSSJE"],
      },
    ],
  },
  {
    faculty: "Rotman School of Management",
    departments: [
      {
        department: "Rotman School of Management",
        programs: [
          "Master of Accounting and Finance",
          "Master of Business Administration",
          "Master of Business Administration (Executive)",
          "Master of Finance",
          "Master of Financial Risk Management",
          "MMA-Management Analytics",
          "Master of Management & Professional Accounting",
          "PHD - Management",
          "Master of Forensic Accounting",
          "Master of Forensic Accounting - Advanced",
          "Master of Management & Professional Accounting - 12 Month",
          "Master of Management & Professional Accounting - 24 Month",
          "Special Student - MGT",
          "PhD - GDM",
          "Special Student - GDM",
        ],
      },
    ],
  },
  {
    faculty: "Scarborough Campus",
    departments: [
      {
        department: "Management (UTSC)",
        programs: ["Masters - MGTSC", "PhD - MGTSC", "Special Student - MGTSC"],
      },
      {
        department: "Physical & Environmental Sciences",
        programs: ["Masters - PESSC", "PhD - PESSC", "Special Student - PESSC"],
      },
      {
        department: "Psychological Clinical Science",
        programs: ["Masters - PSYSC", "PhD - PSYSC", "Special Student - PSYSC"],
      },
    ],
  },
  {
    faculty: "Temerty Faculty of Medicine",
    departments: [
      {
        department: "Biochemistry",
        programs: ["Masters - BCH", "PhD - BCH", "Special Student - BCH"],
      },
      {
        department: "Immunology",
        programs: ["MSC-Immunology", "PHD-Immunology", "Special Student - IMM"],
      },
      {
        department: "Institute of Medical Science",
        programs: [
          "MENG-Medical Science",
          "Master of Health Science",
          "MSc-Medical Science",
          "PhD-Medical Science",
          "PHD (direct entry) - Medical Science",
          "Collaborative Program (M.Sc.) in Bioethics",
          "Collaborative Program (M.Sc.) in Biomedical",
          "Collaborative Program (Ph.D) in Developmental",
          "Masters of Environment and Health",
          "Collaborative Program (Ph.D.) in Health Care,",
          "PhD-Fld:Bioethics",
          "PhD-Fld:Clinical & Evaluative",
          "Special Student - MSC",
        ],
      },
      {
        department: "Laboratory Medicine & Pathobiology",
        programs: [
          "MHSC-Laboratory Medicine & Pathobiology",
          "PHD-Laboratory Medicine & Pathobiology",
          "PHD (direct entry) - Laboratory Medicine & Pathobiology",
          "Special Student - LMP",
        ],
      },
      {
        department: "Medical Biophysics",
        programs: [
          "MSC-Medical Biophysics",
          "PHD-Medical Biophysics",
          "Special Student - MBP",
        ],
      },
      {
        department: "Molecular Genetics",
        programs: ["Masters - MEDGM", "PhD - MEDGM", "Special Student - MEDGM"],
      },
      {
        department: "Nutritional Sciences",
        programs: ["Masters - NUSCI", "PhD - NUSCI", "Special Student - NUSCI"],
      },
      {
        department: "Occupational Science & Occupational Therapy",
        programs: [
          "Master of Science in Occupational Therapy - One year program",
          "Master of Science in Occupational Therapy - Two year program",
          "Special Student - OCT",
        ],
      },
      {
        department: "Pharmacology & Toxicology",
        programs: [
          "MSC-Pharmacology",
          "PHD-Pharmacology",
          "PHD (direct entry) - Pharmacology",
          "Special Student - PCL",
        ],
      },
      {
        department: "Physical Therapy",
        programs: [
          "Master of Science in Physical Therapy - One year program",
          "Master of Science in Physical Therapy - Two year program",
          "Special Student - PHT",
        ],
      },
      {
        department: "Physiology",
        programs: [
          "MHSC-Medical Physiology",
          "MSC-Physiology",
          "PHD-Physiology",
          "PHD (direct entry) - Physiology",
          "Special Student - PSL",
        ],
      },
      {
        department: "Rehabilitation Sciences Institute",
        programs: ["Masters - REHSC", "PhD - REHSC", "Special Student - REHSC"],
      },
      {
        department: "Speech-Language Pathology",
        programs: [
          "MHSC-Speech & Language Pathology (1yr)",
          "MHSC - Speech-Language Pathology (2yr)",
          "MSC-Speech & Language Pathology (1yr)",
          "MSC-Speech & Language Pathology (2yr)",
          "PHD-Speech & Language Pathology",
          "Special Student - SLP",
        ],
      },
    ],
  },
  {
    faculty: "Toronto School of Theology",
    departments: [
      {
        department: "Toronto School of Theology",
        programs: ["Masters - TST", "PhD - TST", "Special Student - TST"],
      },
    ],
  },
];
